import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Paper,
  ClickAwayListener,
  Typography,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import ReplayIcon from "@mui/icons-material/Replay";
import Button from "../../../CommonComponents/common/button/Button";

const options = [
  "Inventory",
  "Purchase Orders",
  "Inbound Shipments",
  "Sales Orders",
  "Outbound Shipments",
];

const disabledOptions = [];
const defaultVisible = options.slice(0, 5);

const SearchWidget = ({ onVisibilityChange }) => {
  const loadWidgets = () => JSON.parse(localStorage.getItem("widgets"));
  const [open, setOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(loadWidgets() || []);
  const [visibleWidgets, setVisibleWidgets] = useState(
    loadWidgets() || defaultVisible
  );

  const toggleDropdown = () => setOpen((prev) => !prev);

  const handleOptionClick = (option) => {
    if (disabledOptions.includes(option)) return;
    setSelectedOptions((prev) =>
      prev.includes(option)
        ? prev.filter((o) => o !== option)
        : [...prev, option]
    );
  };

  const handleSave = () => {
    setVisibleWidgets(selectedOptions.length ? selectedOptions : []);
    localStorage.setItem("widgets", JSON.stringify(selectedOptions));
    setOpen(false);
  };

  const handleReset = () => {
    setSelectedOptions([]);
    setVisibleWidgets(defaultVisible);
    localStorage.removeItem("widgets");
  };

  useEffect(() => {
    onVisibilityChange(visibleWidgets);
  }, [visibleWidgets, onVisibilityChange]);

  return (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      <IconButton onClick={toggleDropdown} aria-label="open-search-widget">
        <SettingsIcon />
      </IconButton>

      {open && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Paper
            elevation={4}
            sx={{
              position: "absolute",
              top: "100%",
              zIndex: 20,
              mt: 1,
              p: 1.5,
              width: 260,
              minHeight: 300,
              bgcolor: "#121212",
              color: "#fff",
              borderRadius: 2,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                fontSize: "1rem",
                mb: 2,
                borderBottom: "1px solid #555",
                pb: 1,
              }}
            >
              Show/Hide Widgets
            </Typography>

            <Box>
              {options.map((option) => {
                const isSelected = selectedOptions.includes(option);
                const isDisabled = disabledOptions.includes(option);

                return (
                  <Box
                    key={option}
                    onClick={() => handleOptionClick(option)}
                    sx={{
                      px: 1.5,
                      py: 0.75,
                      mb: 0.75,
                      fontSize: "0.875rem",
                      border: isSelected
                        ? "2px solid #fff"
                        : "1px solid #333",
                      borderRadius: 1,
                      backgroundColor: isSelected
                        ? "#1e1e1e"
                        : "transparent",
                      cursor: isDisabled ? "not-allowed" : "pointer",
                      opacity: isDisabled ? 0.4 : 1,
                      "&:hover": isDisabled
                        ? {}
                        : {
                            borderColor: "#fff",
                            backgroundColor: "#1e1e1e",
                          },
                    }}
                  >
                    {option}
                  </Box>
                );
              })}
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Box sx={{ width: 80 }}>
                <Button
                  type="success"
                  label="Save"
                  onClick={handleSave}
                  size="small"
                  fullWidth
                />
              </Box>
            </Box>

            <Box sx={{ borderTop: "1px solid #555", my: 1 }} />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <ReplayIcon sx={{ fontSize: 16, color: "#aaa" }} />
                <Typography
                  variant="caption"
                  sx={{ color: "#aaa", fontStyle: "italic" }}
                >
                  Reset to Default Layout
                </Typography>
              </Box>
              <Box sx={{ width: 80 }}>
                <Button
                  type="success"
                  label="Reset"
                  onClick={handleReset}
                  size="small"
                  fullWidth
                />
              </Box>
            </Box>
          </Paper>
        </ClickAwayListener>
      )}
    </Box>
  );
};

export default SearchWidget;